module.exports = __webpack_public_path__ + "static/header-background-0858209b1e30053f14abef394aa02875.png";